import { Order } from "@/models/order/order";
import { UserState } from "./modules/user/types";
import { SurchargeState } from "./modules/surcharge/types";

export enum StoreModule {
  Global = "global/",
  User = "user/",
  Order = "order/",
  Surcharge = "surcharge/"
}

export interface RootState {
  global: any;
  user: UserState;
  order: Order;
  surcharge: SurchargeState;
}
